// noinspection GraphQLUnresolvedReference

import { gql, GraphQLClient } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'
import { LoteFragment } from '../interfaces/fragment'
import { LoteApiInputProps, LoteProps } from '../../../interfaces/lote.ts'

const query = gql`
  ${LoteFragment}
  mutation ACTUALIZAR($id: ID!, $input: LoteInput!) {
    loteActualizar(id: $id, input: $input) {
      ...field
    }
  }
`

/**
 * API REST para la actualización de un lote
 * @param id
 * @param input
 */
export const apiLoteActualizar = async (
  id: string,
  input: LoteApiInputProps,
): Promise<LoteProps> => {
  try {
    const client = new GraphQLClient(import.meta.env.ISI_API_URL)
    const token = localStorage.getItem(AccessToken)
    client.setHeader('authorization', `Bearer ${token}`)
    const data: any = await client.request(query, {
      id,
      input,
    })
    return data.loteActualizar
  } catch (e: any) {
    throw new MyGraphQlError(e)
  }
}
